import PropTypes from "prop-types";
import React from "react";
import moment from "moment";
import {FaSolidIcon} from "../FontAwesomeIcons";
import {formatCurrency} from "../../helpers/CurrencyHelpers";
import {TYPE_WALLET_WELFARE} from "../CheckoutDiscount/Wallets/WalletsConstants";

export default class WalletView extends React.Component {

    constructor(props) {
        super(props);
        this.state = {}

        this.backgroundImageStyle = {
            backgroundImage: `url(${this.props.wallet.image_url || ''})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
        };

        this.overlayDarken = {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0,0,0,0.7)',
            zIndex: 0
        };
    }

    getWalletTitle = _ => {
        switch (this.props.wallet.type) {
            case  TYPE_WALLET_WELFARE:
                return "Il tuo welfare"
            default:
                if (this.props.wallet.name) return this.props.wallet.name.toUpperCase()
                return this.props.wallet.type.replaceAll("_", " ").toUpperCase()
        }
    }

    handleClick = _ => {
        this.props.handleOnClick(this.props.wallet)
    }

    render() {
        let w = this.props.wallet
        const humanReadableDate = moment(w.data_inizio).format('ddd D MMM YYYY');

        return (
            <div>
                {
                    w.disabled ? <div className={"bg-warning text-white p-1 pt-2"}>
                        <FaSolidIcon name={"exclamation-triangle"}/>
                        Questa gift card verrà abilitata appena l'attività approverà il tuo ordine #{w.id_operazione}
                    </div> : ''
                }

                <div
                    className={"card card-body bubble-shadow shadow-sm border-0 text-white " + (w.image_url ? "" : "bg-" + w.color)}
                    style={w.image_url ? this.backgroundImageStyle : {}}
                    onClick={this.handleClick}
                >
                    {/* Dark overlay when image is present */}
                    {w.image_url && <div style={this.overlayDarken}></div>}

                    {/* Content (zIndex:1 to stay above overlay) */}
                    <div style={{position: "relative", zIndex: 1}}>
                        <span className={"small"}>#{w.id_wallet}</span>
                        <div className={"d-flex justify-content-between"}>
                            <span className={"font-weight-bold"}>{this.getWalletTitle()}</span>
                            {
                                this.props.handleOnClick && <FaSolidIcon name={"eye"}/>
                            }
                        </div>

                        <div className={"d-flex align-items-center mb-2"}>
                            <h4 className={"mb-0 mr-2"}>{formatCurrency(w.saldo_disponibile, "EUR", "it-IT")}</h4>
                            <div className={"small mt-0"}>su {formatCurrency(w.inbound_balance, "EUR", "it-IT")}</div>
                        </div>

                        <div className={"small"} style={{opacity: "0.8"}}>
                            Disponibile da {humanReadableDate}
                        </div>
                        <div className={"small"} style={{opacity: "0.8"}}>
                            Acquistato a {w.price}€
                        </div>
                    </div>
                </div>

            </div>
        )
    }
}

WalletView.propTypes = {
    wallet: PropTypes.object,
    handleOnClick: PropTypes.func
}
